const moment = require('moment-timezone');
const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate dateTimeDiffBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const from = await evaluateSource(source.from, content, parentContentPath, transientContext, nativeFunctions);
  if (from === undefined) {
    return undefined;
  }
  const to = await evaluateSource(source.to, content, parentContentPath, transientContext, nativeFunctions);
  if (to === undefined) {
    return undefined;
  }
  const units = await evaluateSource(source.units, content, parentContentPath, transientContext, nativeFunctions);
  const fromMoment = moment(new Date(from));
  const toMoment = moment(new Date(to));
  const result = toMoment.diff(fromMoment, units);
  if (Number.isNaN(result)) {
    return undefined;
  }
  return result;
};
module.exports = {
  evaluate
};